import { Collapse } from 'antd';
import { CaretDownOutlined, CaretRightOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FlexWrapper } from '../../theme/common_style';

const StyledCollapse = styled(Collapse)`
  width: 100%;
  margin-bottom: ${({ marginBottom }) => marginBottom || '20px'};
  border: 1px solid transparent !important;
  border-radius: 8px !important;
  background: transparent !important;
  position: relative !important;

  .ant-collapse-item {
    border: none !important;
    border-radius: 8px !important;
    margin-bottom: 0 !important;

    &:last-child {
      border-radius: 8px !important;
    }
  }

  .ant-collapse-header {
    background-color: #ffffff !important;
    padding: 12px 16px !important;
    font-weight: 500 !important;
    border-radius: 8px 8px 0 0 !important;
    border: none !important;

    .ant-collapse-arrow {
      display: none !important;
    }
  }

  .ant-collapse-content {
    border: none !important;
    border-radius: 0 0 8px 8px !important;

    .ant-collapse-content-box {
      background-color: #ffffff !important;
      padding: 0 !important;
    }
  }

  &.ant-collapse-borderless {
    background: transparent !important;
  }

  .ant-collapse-item-active .ant-collapse-header {
    border-radius: 8px 8px 0 0 !important;
  }

  .ant-collapse-item:not(.ant-collapse-item-active) .ant-collapse-header {
    border-radius: 8px !important;
  }
`;

const CustomHeader = ({ title, content, isActive }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%'
    }}>
    <span style={{ fontSize: '20px', fontWeight: 600 }}>{title}</span>
    <FlexWrapper gap="15px">
      {content}
      {isActive ? (
        <CaretDownOutlined style={{ cursor: 'pointer' }} />
      ) : (
        <CaretRightOutlined style={{ cursor: 'pointer' }} />
      )}
    </FlexWrapper>
  </div>
);

const ExpandCollapseWrapperAntD = ({
  title = 'Toggle',
  children,
  defaultExpanded = true,
  content,
  marginBottom
}) => {
  const [isActive, setIsActive] = useState(null);
  const items = [
    {
      key: '1',
      label: <CustomHeader title={title} content={content} isActive={isActive} />,
      children: children
    }
  ];
  useEffect(() => {
    setIsActive(defaultExpanded);
  }, [defaultExpanded]);

  return (
    <>
      {isActive !== null && (
        <StyledCollapse
          items={items}
          defaultActiveKey={defaultExpanded ? ['1'] : []}
          bordered={false}
          expandIcon={() => null}
          size="small"
          onChange={(key) => setIsActive(key.includes('1'))}
          marginBottom={marginBottom}
        />
      )}
    </>
  );
};

export default ExpandCollapseWrapperAntD;

ExpandCollapseWrapperAntD.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  defaultExpanded: PropTypes.bool,
  content: PropTypes.node,
  marginBottom: PropTypes.string
};

CustomHeader.propTypes = {
  title: PropTypes.string,
  content: PropTypes.node,
  isActive: PropTypes.bool
};
